import { createFileRoute } from "@tanstack/react-router";
import { ContactForm } from "~/components/contact-form";
import { Shell } from "~/components/site-shell";
import { breadcrumbs, jsonLd, seoHead } from "~/config/seo";

export const Route = createFileRoute("/contact")({
  head: () => ({
    ...seoHead({
      title: "Contact HostRight",
      description:
        "Get in touch with HostRight for hosting questions, help, and larger workloads.",
      path: "/contact",
    }),
    scripts: [
      jsonLd(
        breadcrumbs([
          { name: "Home", path: "/" },
          { name: "Contact", path: "/contact" },
        ]),
      ),
    ],
  }),
  component: Contact,
});

function Contact() {
  return (
    <Shell>
      <section className="paper-grid">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-20 lg:grid-cols-[.8fr_1.2fr] lg:px-12">
          <div>
            <p className="eyebrow text-moss">Talk to HostRight</p>
            <h1 className="display mt-4 text-6xl font-bold leading-[.9]">
              A clear next step starts here.
            </h1>
            <p className="mt-6 max-w-md text-lg leading-8 text-ink/60">
              Tell us what you are building, where you are stuck, or what larger
              plan you need. We will point you in the right direction.
            </p>
            <div className="mt-9 rounded-2xl bg-ink p-6 text-cream">
              <p className="eyebrow text-leaf">Good for</p>
              <ul className="mt-4 grid gap-3 text-sm text-cream/75">
                <li>Choosing the right hosting plan</li>
                <li>Moving an existing site or service</li>
                <li>Planning a larger workload</li>
              </ul>
            </div>
          </div>
          <ContactForm />
        </div>
      </section>
    </Shell>
  );
}
